import React from 'react';

export type CheckWidget = {
  hideTab?: (status: boolean) => void;
  selected?: boolean;
};

type Props = {
  render: (props: CheckWidget) => any;
};

const Provider = (props: Props) => {
  return <>{props.render({ hideTab: undefined, selected: true })}</>;
};

const checkWidget = <P extends object>(
  Component: React.FunctionComponent<P>
): React.FunctionComponent => (p: any) => (
  <Provider render={(props: any) => <Component {...(props as CheckWidget)} {...(p as any)} />} />
);

export default checkWidget;
